import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putFormTemplate = (
    backend: string,
    token: string,
    id: number,
    Active: number,
    Name: string,
    Description: string,
    ChangedByID: number,
    components?
) => {
    return fetch(
        `${getApiUrl(backend)}form_templates/${id}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Active,
                Name,
                Description,
                ChangedByID,
                CreatedByID: ChangedByID,
                components
            })
        }
    );
};

export default putFormTemplate;
